import { render, staticRenderFns } from "./Advances.vue?vue&type=template&id=5a0904f6"
import script from "./Advances.vue?vue&type=script&lang=js"
export * from "./Advances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports